import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const Spinner = () => (
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      <td colSpan='11' style={{ textAlign: 'center' }}>
        <FontAwesomeIcon icon={faCircleNotch} size="3x" style={{ color: '#050139', margin: 'auto' }} spin />
      </td>
    </div>
  );
  

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/App/Spinner.js